import { createContext } from "react";
import { type HarvestLog } from "../utils/types";

// This is what we use for taking all the picups from the PickupContext and transforming them into a format that can be used for our printable tables.

export interface HarvestLogContextType {
  harvestLogs: HarvestLog[];
  loading: boolean;
  error: string | null;
  createLog: (log: HarvestLog) => Promise<void>;
  deleteLog: (id: string) => Promise<void>;
  deleteAllLogs: () => Promise<void>;
}

export const HarvestLogContext = createContext<HarvestLogContextType>({
  harvestLogs: [],
  loading: false,
  error: null,
  createLog: async () => {},
  deleteLog: async () => {},
  deleteAllLogs: async () => {},
});
